import { padZero } from '@/utils/number'

/** Polyfillのラッパーutil **/
export { default as scrollIntoView } from '@/utils/scrollIntoView'

/** ブラウザ用エラーメッセージ */
export const showError = text => {
  if (!['test', 'production'].includes(process.env.NODE_ENV)) {
    console.log(`%c${text}`, 'color: red; font-weight: bold;')
  }
}

/** 時間の重複判定 */
export const isDatetimeOverlap = (start1, end1, start2, end2) => start1 < end2 && end1 > start2

/** 時刻表示を分に換算 */
export const toMinute = time => {
  const _timeSliceStart = 0
  const _timeSliceCenter = 2
  const _timeSliceEnd = 4
  return (
    Number(time.slice(_timeSliceStart, _timeSliceCenter) * 60) + Number(time.slice(_timeSliceCenter, _timeSliceEnd))
  )
}

/** 分を時刻に換算 */
export const minuteToTime = time => {
  const minutes = time % 60
  const hours = (time - minutes) / 60
  return `${padZero(hours)}${padZero(minutes)}`
}

/** 遅延付与 */
export const wait = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
